import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Form, Input, Layout, Divider, Button, message, Card } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { loginStart, loginSuccess, loginFailure } from "../../redux/userSlice";
import auth from "../../services/auth";
import AuthLayout from "../../components/layout/AuthLayout";
import AuthSideContent from "./../../components/layout/AuthSideContent";
import "./index.css";
import { UnlockOutlined } from "@ant-design/icons";
import logo from "../../assets/logogg.png";

const { Content } = Layout;

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [msgApi, contextHolder] = message.useMessage();

  useEffect(() => {
    const tokenAlready = localStorage.getItem("token");
    if (tokenAlready) {
      navigate("/bkdashboard");
    }
  }, [navigate]);

  const handleFormSubmit = async (values) => {
    setLoading(true);
    dispatch(loginStart());
    try {
      const response = await auth.login(values);
      if (response?.data?.token) {
        const token = response.data.token;
        localStorage.setItem("token", token);
        dispatch(loginSuccess(response.data));
        navigate(location?.state?.prevUrl || "/bkdashboard");
        msgApi.success("Login successful");
      } else {
        dispatch(loginFailure());
        msgApi.error("Login failed. Check your credentials.");
      }
    } catch (error) {
      dispatch(loginFailure());
      msgApi.error(
        error?.response?.data?.message || "Login failed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout sideContent={<AuthSideContent />}>
      {contextHolder}
      <Content
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#f4dba7e6",
          padding: 20,
        }}
      >
        <Card
          style={{
            width: 400,
            borderRadius: 12,
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            textAlign: "center",
          }}
        >
          <img
            src={logo}
            alt="GaspDelivery Logo"
            width={120}
            style={{ marginBottom: 20, cursor: "pointer" }}
            onClick={() => navigate("/")}
          />
          <h1 style={{ marginBottom: 0 }}>Sign In</h1>
          <Divider />
          <Form layout="vertical" onFinish={handleFormSubmit}>
            <Form.Item
              name="email"
              rules={[{ required: true, message: "Please enter your email" }]}
            >
              <Input size="large" placeholder="Email Address" />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[{ required: true, message: "Please enter your password" }]}
            >
              <Input.Password size="large" placeholder="Password" />
            </Form.Item>
            <Button
              loading={loading}
              size="large"
              type="primary"
              htmlType="submit"
              block
              style={{ borderRadius: 6 }}
            >
              Login
            </Button>
            <div style={{ marginTop: 16, textAlign: "right" }}>
              <a href="/forgot-password">
                <UnlockOutlined /> Forgot password?
              </a>
            </div>
          </Form>
        </Card>
      </Content>
    </AuthLayout>
  );
};

export default Login;
